import { RootState } from '../app/store';
import { StudentCovidDataFilter } from './types';

export const selectStudents = (filterBy: StudentCovidDataFilter) => (state: RootState) => {
  const studentList = state.students[filterBy];
  return studentList.listOrder.map((userId) => (userId ? studentList.students[userId]! : undefined));
};
